import BaseEnum from './base_enum';

export default {
  colors: [
    new BaseEnum('silver', 'Prata'),
    new BaseEnum('gold', 'Ouro'),
    new BaseEnum('bronze', 'Bronze')
  ]
};
